import { useState, useMemo } from "react";
import { TextField, MenuItem, Select, IconButton, Checkbox, FormControl, Autocomplete, InputAdornment } from "@mui/material";
import { CiCirclePlus } from "react-icons/ci";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import FileUpload from "../FileUpload";
import { useFetchGetAllProjectBasedUserNameListQuery, useFetchIssueModuleDropdownQuery, useFetchNotificationListQuery, useFetchUserAccessedProjectsQuery } from "../../../slice/logdetailSlice";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { postResource } from "../../../apis/apiService";
import { BtnLoader } from "../Loader";
import { toast } from "react-toastify";
import QuillComponent from "../ReactQuill";
import { skipToken } from "@reduxjs/toolkit/query";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useTheme } from "../../../ThemeContext";


export const CommonAddIssue = ({
  onApply,
  onClear,
  onCancel,
  fetchIssues,
  isModule,
  project_id,
  path,
  isTaskDetail,
  taskId,
}) => {
  const { isDarkMode } = useTheme();
  
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    register,
    clearErrors,
  } = useForm({
    defaultValues: {
      Assignee: "",
      DueDate: undefined,
      Severity: "",
      issue_name: "",
      Module: "",
      Priority: "",
      uploadedFile: [],
      description: "",
      followers: [],
    },
  });
  // const { id } = useParams();
  // const projectBasedUsers = useSelector(
  //   (state) => state.selectOptions?.userNamesByProjects
  // );
  const [selectedProject, setSelectedProject] = useState(
    isModule ? null : project_id
  );
  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();
  // const { data: projectBasedUsers } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedProject, {
      skip: !selectedProject,
    });
  // //console.log()("login_user_detail matching========= value :", projectBasedUsers);

  const priorityList = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  const priorityOptions = priorityList?.find((list) => list.priority_type === "ISSUE") || { priority_details: [] }; // Default empty array

  const serverityList = useSelector((state) => state.selectOptions?.SeverityNameOptions) || []; // Default empty array
  // //console.log()("SeverityNameOptions : ", serverityList);

  // //console.log()("PriorityList: ", priorityOptions);

  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  // const { id: login_user_id } = loginUser;
  // //console.log()("login_user_detail :id", login_user_id, "name :", name);
  
  const { data: usersInProjects } = useFetchGetAllProjectBasedUserNameListQuery(
    selectedProject,
    { skip: !selectedProject }
  );
  // //console.log()("users_in_projects usersInProjects project :", usersInProjects);
  const [loading, setLoading] = useState(false);
  const [clearFile, setClearFile] = useState(false);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [showModel, setShowModel] = useState(true);
  const [searchText, setSearchText] = useState("");
  // const [isOpen, setIsOpen] = useState(false);
  const filter = createFilterOptions();


  // Filter options based on search text

  const { refetch: notification_refetch } = useFetchNotificationListQuery();

  const addMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => addMoreIssue(data))();
  };

  const { data: issue_module_dropdown, refetch: module_refetch } =
    useFetchIssueModuleDropdownQuery(selectedProject ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });
  // console.log("issue_module_dropdown :", issue_module_dropdown);

    useMemo(() => {
    if (!Array.isArray(issue_module_dropdown))
      return issue_module_dropdown || [];
    return issue_module_dropdown.filter((item) =>
      item?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, issue_module_dropdown]);

  const addMoreIssue = async (data) => {
    const formData = new FormData();

    // Append form fields
    formData.append("issue_name", data.issue_name);
    formData.append("due_date", data.DueDate ? dayjs(data.DueDate).format("YYYY-MM-DD") : "");
    formData.append("module", data.Module || "");
    formData.append("description", data.description || "");
    formData.append("severity_id", data.Severity ? parseInt(data.Severity, 10) : "");
    formData.append("priority_id", data.Priority ? parseInt(data.Priority, 10) : "");
    formData.append("assignee", data.Assignee);

    // Append file if uploaded
    if (uploadedFile) {
      uploadedFile.forEach((file) => {
        formData.append("document[]", file);
      });
    }

    // Append followers as array
    data.followers.forEach((follower, index) => {
      formData.append(`followers[${index}]`, follower);
    });

    setLoading(true);
    try {
      // //console.log()("Request Payload:", formData);
      // Send FormData
      const response = await postResource( path, "add",
        isTaskDetail ? taskId : selectedProject,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // //console.log()("API Response:", response);
      if (response) {
        toast.success(response.message || "Issue added successfully!");
        fetchIssues();
        // issue_module_refetch();
        notification_refetch();
        setUploadedFile([]);
        module_refetch();
        setClearFile((prev) => !prev);
        reset();
      }
      // onCancel();
    } 
    catch (err) {
      // console.error(
      //   "Error during API call:",
      //   err.response?.data || err.message
      // );
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!showModel) {
  //     // Reset the "Module" field value when switching to TextField
  //     // reset({ Module: "" });
  //   }
  // }, [showModel, reset]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    // Append form fields
    formData.append("issue_name", data.issue_name);
    formData.append("due_date",data.DueDate ? dayjs(data.DueDate).format("YYYY-MM-DD") : "");
    formData.append("module", data.Module || "");
    formData.append("description", data.description || "");
    formData.append("severity_id",data.Severity ? parseInt(data.Severity, 10) : "");
    formData.append("priority_id", data.Priority ? parseInt(data.Priority, 10) : "");
    formData.append("assignee", data.Assignee);

    // Append file if uploaded
    if (uploadedFile) {
      uploadedFile.forEach((file) => {
        formData.append("document[]", file);
      });
    }

    // Append followers as array
    data.followers.forEach((follower, index) => {
      formData.append(`followers[${index}]`, follower);
    });

    setLoading(true);
    try {
      // //console.log()("Request Payload:", formData);
      // Send FormData
      const response = await postResource(
        path,
        "add",
        isTaskDetail ? taskId : selectedProject,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // //console.log()("API Response:", response);
      if (response) {
        toast.success(response.message || "Issue added successfully!");
        fetchIssues();
        notification_refetch();
        module_refetch();
        // issue_module_refetch();
        onCancel();
      }
    } 
    catch (err) {
      // console.error(
      //   "Error during API call:",
      //   err.response?.data || err.message
      // );
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Submit Issue
          </div>
        </button>
      </div>

      <div className="bg-white overflow-scroll pb-5 pt-3 px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              {isModule && (
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="project_id" className="form-label">
                      Project Name <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="project_id"
                      control={control}
                      rules={{ required: "Project field is required" }}
                      render={({
                        field: { onChange, value },
                        formState: { errors },
                      }) => (
                        <>
                           <Autocomplete
                            id="project_id"
                            popupIcon={<ExpandMore />}
                            options={
                              Array.isArray(user_accessed_project)
                                ? user_accessed_project
                                : []
                            }
                            getOptionLabel={(option) => option?.title || ""}
                            value={
                              user_accessed_project?.find(
                                (user) => user.project_id === value
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                if (Array.isArray(newValue)) {
                                  toast.error("You can select only one project.");
                                } 
                                else {
                                  onChange(newValue.project_id);
                                  setSelectedProject(newValue.project_id);
                                }
                                } 
                                else {
                                     onChange(null);
                                     setSelectedProject(null);
                                   }
                                 }}
                                 renderOption={(props, option) => (
                                   <li {...props} className="d-flex align-items-center mb-2">
                                     <Checkbox 
                                       style={{ marginRight: 8 }} 
                                       checked={value === option.project_id} 
                                     />
                                     <strong>{option.title}</strong>
                                   </li>
                                 )}
                                 renderInput={(params) => (
                              <TextField {...params} placeholder="Select project" />
                            )}

                            noOptionsText="No project found"
                            componentsProps={{
                              noOptions: {
                                sx: (theme) => ({
                                  textAlign: "center",
                                  fontWeight: 500,
                                  py: 1.5,
                                  fontSize: 14,
                                  color:
                                    theme.palette.mode === "dark"
                                      ? theme.palette.grey[400]
                                      : theme.palette.grey[600],
                                }),
                              },
                            }}

                            filterOptions={(options, params) => {
                              const filtered = filter(options, params);
                              // ✅ If search is empty, show all options
                              if (params.inputValue.trim() === "") {
                                return options;
                              }
                              return filtered;
                            }}
                          />
                          <span className="errorMsg">
                            {errors?.project_id?.message}
                          </span>
                        </>
                      )}
                    />
                  </div>
                </div>
              )}

              {selectedProject && (
                <>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="issue_name" className="form-label">
                        Issue Name <span className="errorMsg">*</span>
                      </label>
                      <TextField
                        type="text"
                        id="issue_name"
                        placeholder="Enter Issue Name"
                        // className="form-control"
                        sx={{ width: "100%" }}
                        {...register("issue_name", {
                          required: "The issue name field is required",
                        })}
                      />
                      {errors.issue_name && (
                        <p className="errorMsg">{errors.issue_name.message}</p>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="description" className="form-label">
                        Add Description
                      </label>
                      <QuillComponent control={control} name="description" />
                      {/* <ReactQuill/> */}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="Module" className="form-label">
                        Module <span className="errorMsg">*</span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <div className="flex-grow-1">
                          {showModel ? (
                            <FormControl fullWidth size="small">
                              <Controller
                                name="Module"
                                control={control}
                                defaultValue={null}
                                rules={{ required: "Module field is required" }}
                                render={({ field: { onChange, value } }) => {
                                  const filteredModules = (issue_module_dropdown || [])?.filter((item) =>                               
                                    item.toLowerCase().includes(searchText.toLowerCase())
                                  );

                                  return (
                                    <Autocomplete
                                      fullWidth
                                      size="small"
                                      popupIcon={<ExpandMore />}
                                      options={filteredModules || []}
                                      value={value || null}
                                      onChange={(e, newValue) => {
                                        onChange(newValue);
                                        setSearchText("");
                                      }}

                                      getOptionLabel={(option) => option || ""}
                                      isOptionEqualToValue={(option, val) => option === val}
                                      noOptionsText="No module found"
                                      sx={{
                                        "& .MuiAutocomplete-noOptions": {
                                          color: "#ccc !important", // ✅ uses theme grey text
                                          fontStyle: "italic",
                                          fontSize: 13,
                                          textAlign: "center",
                                          py: 1,
                                        },
                                      }}

                                      renderOption={(props, option, { selected }) => (
                                        <li {...props} className="d-flex align-items-center mb-1">
                                          <Checkbox checked={selected} style={{ marginRight: 8 }} />
                                          <strong>{option}</strong>
                                        </li>
                                      )}

                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Select Module"
                                          variant="outlined"
                                          value={searchText}
                                          onChange={(e) => setSearchText(e.target.value)}
                                          InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                {/* optional search icon */}
                                              </InputAdornment>
                                            ),
                                            sx: {
                                              fontWeight: 500,
                                              fontSize: 13,
                                              borderRadius: "8px",
                                              padding: "6px 12px",
                                              height: 36,
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  );
                                }}
                              />

                            </FormControl>
                          ) : (
                            <TextField
                              type="text"
                              id="Module"
                              sx={{ width: "100%" }}
                              placeholder="Enter Module"
                              {...register("Module", {
                                required: "Module field is required",
                              })}
                            />
                          )}
                        </div>

                        <IconButton
                          onClick={() => setShowModel((prev) => !prev)}
                          sx={{
                            backgroundColor: isDarkMode
                              ? "rgba(67, 105, 255, 0.08)"
                              : "#F1F5FF",
                            borderRadius: "50%",
                            width: "38px",
                            height: "38px",
                            "&:hover": {
                              backgroundColor: "var(--icon-hover-bg)",
                            },
                          }}
                        >
                          <CiCirclePlus size={24} className="pro-icon-s text-rgbr-blue" />
                        </IconButton>
                      </div>
                      {errors.Module && (
                        <p className="errorMsg">{errors.Module.message}</p>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="Upload File" className="form-label">
                        Upload File
                      </label>
                      <FileUpload
                        onFileChange={(file) => setUploadedFile(file)}
                        clearTrigger={clearFile}
                      />
                    </div>
                  </div>

                  <div className="col-md-12 my-3">
                    <label htmlFor="followers" className="form-label">
                      Add Followers
                    </label>
                    <Controller
                      name="followers"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          multiple
                          id="followers"
                          popupIcon={<ExpandMore />}
                          options={usersInProjects || []}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option?.name || ""}
                          value={
                            (value || [])
                              .map((user_id) =>
                                usersInProjects?.find(
                                  (user) => user.user_id === user_id
                                )
                              )
                              .filter(Boolean)
                          }
                          onChange={(event, newValue) => {
                            const selectedTitles = newValue.map(
                              (user) => user.user_id
                            );
                            onChange(selectedTitles);
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.name}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Add followers" />
                          )}
                          ListboxProps={{
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "8px",
                              paddingLeft: "0",
                            },
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="Assignee" className="form-label">
                        Assignee <span className="errorMsg">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="Assignee"
                        render={({
                          field: { ref, onChange, ...fieldProps },
                        }) => (
                          <FormControl fullWidth>
                            <Select
                              {...fieldProps}
                              inputRef={ref}
                              onChange={(e) => {
                                onChange(e);
                                clearErrors("Assignee");
                              }}
                              displayEmpty
                              renderValue={(selected) =>
                                selected ? (
                                  usersInProjects?.find(
                                    (user) => user.user_id === selected
                                  )?.name
                                ) : (
                                  <span className="lightText">Assignee</span>
                                )
                              }
                              labelId="Assignee-label"
                              id="Assignee"
                              IconComponent={ExpandMore}
                            >
                              {usersInProjects?.map((user, index) => (
                                <MenuItem key={index} value={user.user_id}>
                                  {user.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                        rules={{ required: "Assignee field is required" }}
                      />
                      {errors.Assignee && (
                        <p className="errorMsg">{errors.Assignee.message}</p>
                      )}
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="DueDate" className="form-label">
                        Due Date
                      </label>
                      <div className=" d-flex  flex-column w-100 ">
                        <Controller
                          name="DueDate"
                          control={control}
                          rules={{
                            validate: (val) => {
                              if (!val) return true;
                              const d = dayjs(val);
                              if (!d.isValid()) return "Invalid date";
                              if (d.year() < 1990) return "Invalid date format";
                              return true;
                            }
                          }}
                          render={({ field }) => (
                            <>
                              <DatePicker
                                {...field}
                                format="DD/MM/YYYY"
                                disablePast
                                onChange={(date) => field.onChange(date)}
                                renderInput={(params) => (
                                  <input className="form-control" {...params} />
                                )}
                              />
                              {errors.DueDate && (
                                <span className="errorMsg">
                                  {errors.DueDate.message}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Priority" className="form-label">
                        Priority <span className="errorMsg">*</span>
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="Priority"
                          control={control}
                          rules={{ required: "Priority field is required" }}
                          render={({
                            field: { onChange, value, ref },
                            fieldState: { error },
                          }) => (
                            <>
                              <Select
                                onChange={onChange}
                                inputRef={ref}
                                value={value}
                                displayEmpty
                                IconComponent={ExpandMore}
                                renderValue={(selected) => {
                                  const selected_value =
                                    priorityOptions?.priority_details.find(
                                      (list) => list.priority_id === selected
                                    );
                                  return selected_value ? (
                                    <span
                                      style={{
                                        color:
                                          selected_value.priority_colour ||
                                          "black",
                                      }}
                                    >
                                      {selected_value.priority_name}
                                    </span>
                                  ) : (
                                    <span className="lightText">
                                      Select priority
                                    </span>
                                  );
                                }}
                                // IconComponent={ExpandMoreIcon}
                              >
                                {priorityOptions?.priority_details.map(
                                  (priority) => (
                                    <MenuItem
                                      key={priority?.priority_id}
                                      // color={priority?.priority_color}
                                      sx={{
                                        color:
                                          priority?.priority_colour || "black",
                                      }}
                                      value={priority?.priority_id}
                                    >
                                      {priority?.priority_name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                              {error && (
                                <span className="errorMsg">
                                  {error.message}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </FormControl>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Severity" className="form-label">
                        Severity <span className="errorMsg">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="Severity"
                        rules={{ required: "Severity field is required" }}
                        render={({
                          field: { ref, onChange, ...fieldProps },
                        }) => (
                          <FormControl fullWidth>
                            <Select
                              inputRef={ref}
                              {...fieldProps}
                              onChange={(e) => {
                                onChange(e);
                                clearErrors("Severity");
                              }}
                              displayEmpty
                              renderValue={(selected) => {
                                const selected_value = serverityList?.find(
                                  (list) => list.severity_id === selected
                                );
                                return selected_value ? (
                                  <span
                                    style={{
                                      color:
                                        selected_value.severity_colour ||
                                        "black",
                                    }}
                                  >
                                    {selected_value.severity_name}
                                  </span>
                                ) : (
                                  <span className="lightText">
                                    Select severity
                                  </span>
                                );
                              }}
                              labelId="Severity-label"
                              id="Severity"
                              IconComponent={ExpandMore}
                            >
                              {serverityList.map((list, index) => (
                                <MenuItem
                                  key={index}
                                  sx={{
                                    color: list.severity_colour || "black",
                                  }}
                                  value={list.severity_id}
                                >
                                  {list.severity_name}
                                </MenuItem>
                              ))}

                              {/* Add other options */}
                            </Select>
                          </FormControl>
                        )}
                        // rules={{ required: "Severity field is required" }}
                      />
                      {errors.Severity && (
                        <span className="errorMsg">
                          {errors.Severity.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="paddingBtn"></div>
                </>
              )}

              <div className="bg-white    position-absolute w-100 bottom-0 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                  
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    disabled={loading}
                    onClick={addMore}
                  >
                    {/* {loading ? (
                      <>
                        Add more
                        <BtnLoader />
                      </>
                    ) : (
                      "Add more"
                    )} */}
                    Add more
                  </button>
                  <button
                    type="button"
                    disabled={loading}
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
